// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"128":"40bb8fc7","763":"6b193fd8"}[chunkId] + ".chunk.css");